import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { some } from 'constants/constants';
import SearchBooker from 'modules/component/Booker/Main/SearchBookerMain';

const Home = (props: some) => {
  return (
    <>
      <SearchBooker />
    </>
  );
};

export default connect()(withRouter(Home));
